import React					from 'react';

import {SelectData}				from '../components/Select/interface';
import Avatar					from '../components/Avatar';
import Icon						from '../components/Icon';

import {User}					from '../../redux/user/interface';
import {LanguageType} 			from '../language/type';

import {STOCKAGE_LIST,
	MEMORY_LIST, YEAR_LIST,
	NETWORK_LIST}				from '../data/device';


interface SelectStingIcon {
	value: string | number,
	text: string,
	icon: string
}

export function ft_selectDataUser(users: User[]) {
	const userSelect: SelectData[] = [];

	users.forEach((user) => {
		if (!user)
			return;

		userSelect.push({
			value:  user._id,
			render: (
				<div>
					<Avatar user={user} />
					<span>{`${user.firstname || ''} ${user.lastname || ''}`}</span>
				</div>
			)
		});
	});

	return userSelect;
}

export function ft_selectPlaceholderUser(TEXTE: LanguageType) {
	return (
		<div>
			<Avatar />
			<span>{TEXTE.devices.affect}</span>
		</div>
	);
}

export function ft_selectDataString(stringArray: (string | number)[], specialRender?: (val: string) => React.ReactElement) : SelectData[] {
	return stringArray.map((e) => {
		return ({
			value:  e as string,
			render: specialRender ? specialRender(e as string) : e.toString()
		});
	});
}

export function ft_selectDataStringIcon(data: SelectStingIcon[], iconColor?: string) : SelectData[] {
	const getRender = (icon: string, text: string) => {
		return (
			<div>
				<Icon icon={icon} iconColor={iconColor} />
				{text}
			</div>
		);
	};

	return data.map((e) => {
		return ({
			value:  e.value.toString(),
			render: getRender(e.icon, e.text)
		});
	});
}

export const ft_selectDataGetStockage = () => ft_selectDataString(STOCKAGE_LIST);
export const ft_selectDataGetMemory = () => ft_selectDataString(MEMORY_LIST);
export const ft_selectDataGetNetwork = () => ft_selectDataString(NETWORK_LIST);
export const ft_selectDataGetYear = () => ft_selectDataString(YEAR_LIST);